import { createContext } from 'react';

export interface AccountApprovalContextType {
    approverParentEmail: string | null;
    approverParentHasGivenConsent: boolean;
}

const initialAccountApprovalContext = {
    approverParentEmail: null,
    approverParentHasGivenConsent: false,
};

export const AccountApprovalContext = createContext<AccountApprovalContextType>(initialAccountApprovalContext);
